/**
 * Themes Module
 *
 * Exports all theme definitions and utilities.
 * Import from this file to access themes and theme utilities.
 */

import darkTheme from './dark';
import lightTheme from './light';
import obsidianAmberDarkTheme from './obsidianAmberDark';
import obsidianAmberLightTheme from './obsidianAmberLight';
import slateVioletDarkTheme from './slateVioletDark';
import slateVioletLightTheme from './slateVioletLight';

export {
  darkTheme,
  lightTheme,
  obsidianAmberDarkTheme,
  obsidianAmberLightTheme,
  slateVioletDarkTheme,
  slateVioletLightTheme,
};
export {
  generateCSSVariables,
  applyCSSVariables,
  removeCSSVariables,
  applyTheme,
} from './themeUtils';

// Theme registry for easy lookup
export const themes = {
  light: lightTheme,
  dark: darkTheme,
  'obsidian-amber-light': obsidianAmberLightTheme,
  'obsidian-amber-dark': obsidianAmberDarkTheme,
  'slate-violet-light': slateVioletLightTheme,
  'slate-violet-dark': slateVioletDarkTheme,
};

export const themeOrder = [
  'light',
  'dark',
  'obsidian-amber-light',
  'obsidian-amber-dark',
  'slate-violet-light',
  'slate-violet-dark',
];

export const defaultThemeOrder = [
  'light',
  'dark',
];

export const normalizeThemeName = (themeName) => {
  return themeName;
};

// Default theme
export const defaultTheme = 'dark';
